<template>
  <div v-if="broadcast">
    <v-container>
      <v-layout mb-3 align-center>
        <v-flex lg-9>
          <div style="display: flex; gap: 5px">
            <img
              @click="onBack"
              src="/static/img/arrow_back.png"
              alt
              class="responsive-img pointer"
              style="height: 24px; margin-top: 5px"
            />
            <div style="flex-wrap: wrap; width: 80%">
              <Typography h2 bold :label="broadcast.name" />
            </div>
          </div>
        </v-flex>
        <v-flex lg-3 class="text-right">
          <toggle-button
            :value="false"
            :sync="true"
            :color="{ checked: $vuetify.theme.success, unchecked: '#BFBFBF' }"
            :width="70"
            :height="24"
            :font-size="12"
            @change="onSend"
            :labels="{ checked: 'BROADCAST', unchecked: 'DRAFT' }"
            style="display: inline-block"
          />
        </v-flex>
      </v-layout>

      <v-card elevation="2" style="border-radius: 10px">
        <v-container pt-0 pb-0 pl-3 pr-3>
          <v-tabs
            v-model="viewPage"
            color="white"
            :slider-color="$vuetify.theme.primary"
            style="font-size: 18px"
          >
            <v-tab
              v-for="(item, index) in menuItem"
              :key="`menu-item-${index}`"
              style="text-transform: capitalize"
              ripple
              :href="`#${item.view}`"
              @click="updateSlug(item.view)"
              >{{ item.text }}</v-tab
            >
          </v-tabs>
        </v-container>
        <DetailTab
          v-if="view == 'detail'"
          :value="broadcast"
          :broadcastType="'draft'"
          @showEditNameModal="showEditNameModal = true"
          @showEditTarget="showEditTarget = true"
          @showEditTags="showEditTags = true"
          @showEditTimeSchedule="showEditTimeScheduleFunc"
        >
          <!-- name modal -->
          <edit-modal
            slot="modal"
            v-if="showEditNameModal"
            @onClose="showEditNameModal = false"
            @onSave="onSubmitModal"
            :broadcast="broadcast"
          >
            <Typography slot="editTitle" h2 bold :label="$t('broadcast edit name')" />
            <Typography
              slot="input"
              h5
              semiBold
              color="color-darkGrey"
              :label="$t('Broadcast Name')"
            />
            <div
              slot="input"
              class="form-broadcast"
              :class="{ 'has-error': errors.has('broadcastName') }"
            >
              <input
                type="text"
                class="form-broadcast"
                name="broadcastName"
                placeholder="Broadcast_YYYY_MM_DD_HH_mm"
                data-vv-name="broadcastName"
                :data-vv-as="$t('Broadcast Name')"
                v-validate="'required'"
                v-model="name"
              />
              <span class="text-error" v-show="errors.has('broadcastName')">{{
                errors.first('broadcastName')
              }}</span>
            </div>
          </edit-modal>

          <!-- target modal -->
          <edit-modal
            slot="modal"
            v-if="showEditTarget"
            @onClose="showEditTarget = false"
            @onSave="onSubmitModal"
            :broadcast="broadcast"
          >
            <Typography slot="editTitle" h2 bold :label="$t('broadcast edit target')" />
            <div slot="input">
              <template v-if="loadingEstimate">
                <div style="display: flex; gap: 5px">
                  <Typography h5 semiBold color="color-darkGrey" :label="$t('Target')" />
                  <sync-loader
                    :color="$vuetify.theme.primary"
                    :size="'5px'"
                    style="display: inline-block; margin-bottom: 10px"
                  ></sync-loader>
                </div>
              </template>
              <template v-else>
                <div style="display: flex; gap: 5px">
                  <Typography h5 semiBold color="color-darkGrey" :label="$t('Target')" />
                  <p class="mb-0 color-darkGrey" style="font-size: 16px">
                    {{ '(' }}{{ $t('approximately') }}
                    <template v-if="groupType.value != 'line' && sendtype == 'promotion'">
                      <tween-num
                        :value="parseInt(estimate_user)"
                        :initial="0"
                        :formatter="numberFormat"
                        key="promotion"
                      ></tween-num>
                      <span
                        >&nbsp;{{ $t('users') }}&nbsp;={{
                          $t(`Number of users who talked with chatbot within 24 hours`)
                        }}{{ ')' }}</span
                      >
                    </template>
                    <template v-else>
                      <tween-num
                        :value="parseInt(total_user)"
                        :initial="0"
                        :formatter="numberFormat"
                        key="not_promotion"
                      ></tween-num>
                      <span>&nbsp;{{ $t('users') }}</span>
                    </template>
                  </p>
                </div>
                <Typography
                  v-if="groupType.value != 'line'"
                  h7
                  medium
                  color="color-mediumGrey"
                  :label="
                    $t(
                      '(Importing the previous users before installing the chatbot can be applied with premium package only.)'
                    )
                  "
                />
              </template>
            </div>
            <div
              slot="input"
              class="form-broadcast"
              :style="{
                'padding-bottom': isOpen ? '60px' : '0px',
              }"
            >
              <multiselect
                ref="multiselect"
                class="form-broadcast"
                v-model="groupType"
                :options="groupTypeOptions"
                label="label"
                :allow-empty="false"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                track-by="label"
                @open="isOpen = true"
                @close="isOpen = false"
                @select="onSelectGroupType"
              >
              </multiselect>
              <div style="position: relative" v-if="groupType.value == 'customize'">
                <v-premium-plan-popup
                  :showAll="false"
                  marginTop="65"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <template>
                  <div
                    class="form-broadcast"
                    style="
                      border: 1px solid #beccdb;
                      padding: 5px 10px 0px 10px;
                      border-radius: 10px;
                      margin-top: 15px;
                      background: #e6f0fb;
                    "
                  >
                    <filter-broadcast
                      filterType="boardcast"
                      :total_user="total_user"
                      v-model="filter"
                      @onChangeStatus="onChangeStatus"
                    ></filter-broadcast>
                  </div>
                </template>
              </div>
            </div>
          </edit-modal>

          <!-- tags modal -->
          <edit-modal
            slot="modal"
            v-if="showEditTags"
            @onClose="showEditTags = false"
            @onSave="onSubmitModal"
            :broadcast="broadcast"
          >
            <Typography slot="editTitle" h2 bold :label="$t('broadcast edit tags')" />
            <Typography
              slot="input"
              h5
              semiBold
              color="color-darkGrey"
              :label="$t('Add tag for this broadcast')"
            />
            <div slot="input" class="form-broadcast" :class="{ 'has-error': errorTag.length > 0 }">
              <tags
                class="form-broadcast"
                v-model="test_update_tag"
                :tags="test_update_tags"
                @tags-changed="addTestUpdate"
                @before-adding-tag="checkQuickReply"
                style="margin-bottom: 5px"
                :btnText="$t('Add choice')"
              ></tags>
              
              <span class="text-error" v-if="errorTag.length > 0">
                <template v-if="errorTag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="errorTag.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="errorTag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </div>
          </edit-modal>

          <!-- time modal -->
          <edit-modal
            slot="modal"
            v-if="showEditTimeSchedule"
            @onClose="showEditTimeSchedule = false"
            @onSave="onSubmitModal"
            :broadcast="broadcast"
          >
            <Typography slot="editTitle" h2 bold :label="$t('broadcast edit time')" />
            <div slot="input" class="form-broadcast">
              <v-layout wrap>
                <v-flex xs12 sm6 class="form-broadcast pr-2">
                  <Typography h5 semiBold color="color-darkGrey" label="เลือกวันที่" />
                  <date-picker
                    :append-to-body="true"
                    :clearable="true"
                    :editable="false"
                    input-class="dateSearch"
                    name="DateSearch"
                    valueType="date"
                    v-model="scheduleDate"
                    format="DD/MM/YYYY"
                    placeholder="เลือกวันที่"
                    confirm
                  >
                    <template v-slot:footer="{ emit }">
                      <div style="text-align: left">
                        <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
                      </div>
                    </template>
                  </date-picker>
                </v-flex>
                <v-flex xs12 sm6 class="form-broadcast pl-2">
                  <Typography h5 semiBold color="color-darkGrey" label="เลือกเวลา" />
                  <date-picker
                    :append-to-body="true"
                    :clearable="true"
                    :editable="false"
                    input-class="dateSearch"
                    name="DateSearch"
                    type="time"
                    v-model="scheduleTime"
                    format="HH:mm"
                    placeholder="เลือกเวลา"
                    confirm
                  >
                  </date-picker>
                </v-flex>
              </v-layout>
            </div>
          </edit-modal>
        </DetailTab>

        <MessageTab v-if="view == 'message'" :value="broadcast" :broadcastType="'draft'">
          <broadcast-answers-message
            slot="message"
            v-model="messages"
            :broadcast="broadcast"
            :choice="choices"
            :questions="questions"
            :isComment="false"
            :comment="''"
            :broadcastType="'draft'"
            @onSave="onSave"
          >
            <div slot="tags" class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <tags
                class="form-broadcast"
                v-model="choice"
                :tags="choices"
                @tags-changed="addChoices"
                @before-adding-tag="checkQuickReply"
                style="margin-bottom: 5px"
                :btnText="$t('Add')"
              ></tags>
              <span class="text-error" v-if="errorTag.length > 0">
                <template v-if="errorTag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 100 alphabets')
                }}</template>
                <template v-else-if="errorTag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </div>
          </broadcast-answers-message>
        </MessageTab>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import DatePicker from 'vue2-datepicker'
import IntentGroup from '@/components/view/intent/IntentGroup'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import TweenNum from 'vue-tween-number'
import ModalDialog2 from '@/components/elements/ModalDialog2'
// import { constants } from 'http2';
import Tags from '@/components/elements/TagsBroadcast'
import Multiselect from 'vue-multiselect'
import PreviewMessage from '@/components/elements/PreviewMessage'
import FilterBroadcast from '@/components/elements/FilterBroadcast'
import Typography from '@/components/elements/Typography'
import DetailTab from './Detail'
import MessageTab from './Message'
import EditModal from './EditModal'
import ModalNotify from '@/components/elements/ModalNotify'
import Button from '@/components/elements/Button.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import BroadcastAnswersMessage from './BroadcastAnswersMessage.vue'

export default {
  props: ['value', 'broadcastType'],

  data: function () {
    return {
      isOpen: false,
      showEditNameModal: false,
      showEditTarget: false,
      showEditTags: false,
      showEditTimeSchedule: false,
      showSponser: false,
      showScheduleDate: false,
      showScheduleTime: false,
      scheduleDate: null,
      scheduleTime: null,
      showPreview: false,
      questions: [],
      tagOptions: [],
      update_tag:[],
      tag: '',
      singleStatus: '',
      showUpgrade: false,
      broadcast: undefined,
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      update_status: '',
      update_tags: [],
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than'),
        },
        {
          value: 'l__',
          label: this.$t('Less than'),
        },
        {
          value: 'n__',
          label: this.$t('Not'),
        },
      ],
      groupTypeOptions: [
        {
          label: this.$t('All'),
          value: '',
        },
        // {
        //   label: this.$t('Facebook'),
        //   value: 'facebook',
        // },
        // {
        //   label: this.$t('Line'),
        //   value: 'line',
        // },
        {
          label: this.$t('Customize'),
          value: 'customize',
        },
      ],
      intents: [],
      type: 'json',
      groupType: {
        label: this.$t('All'),
        value: '',
      },
      sendtype: 'promotion',
      pushtype: 'SILENT_PUSH', // REGULAR/SILENT_PUSH/NO_PUSH
      message: '',
      quick_reply: '',
      messages: [[]],
      tag_reply: '',
      test_update_tag: '',
      choice: '',
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all',
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook',
        },
        {
          label: this.$t('Line'),
          value: 'line',
        },
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all',
        },
        {
          label: this.$t('Male'),
          value: 'male',
        },
        {
          label: this.$t('Female'),
          value: 'female',
        },
        {
          label: this.$t('no gender'),
          value: 'other',
        },
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],
          enable: true,
        },
      ],
      filter: {
        membername: '',
        membertype: '',
        memberstatus: '',
        dpType: '',
        projectname: '',
        projecttype: '',
        specialcondition: '',
        fullname: '',
        gender: '',
        locale: null,
        app: {
          label: this.$t('Line'),
          value: 'line',
        },
        intent: null,
        email: '',
        context: '',
        phoneno: '',
        timezone: {
          from: -12,
          to: 14,
        },
        activeDate: {
          enable: false,
          start: null,
          end: null,
        },
        registerDate: {
          enable: false,
          start: null,
          end: null,
        },
        tags: '',
        status: '',
        statustype: 'includes',
      },
      errorTag: [],
      errorFilterTag: [],
      errorFilterStatus: [],
      estimate_user: 0,
      total_user: '',
      loadingEstimate: true,
      menuData: [
        {
          text: this.$t('broadcast tab detail'),
          view: 'detail',
        },
        {
          text: this.$t('broadcast tab message'),
          view: 'message',
        },
      ],
    }
  },
  components: {
    DatePicker,
    IntentGroup,
    GenericManage,
    MoveHorizontal,
    TweenNum,
    SyncLoader,
    ModalDialog2,
    Tags,
    Multiselect,
    PreviewMessage,
    FilterBroadcast,
    Typography,
    DetailTab,
    MessageTab,
    EditModal,
    ModalNotify,
    Button,
    ToggleButton,
    BroadcastAnswersMessage,
  },
  mounted: function () {
    var vm = this
    vm.reset()

    vm.$nextTick(function () {
      if (vm.groupType.value === 'customize') {
        if (vm.$store.getters.getPackage === 'premium') {
          vm.estimateReach(vm.groupType.value)
        } else {
          vm.estimateReach('')
        }
        vm.estimateReach(vm.groupType.value)
      } else {
        if (vm.groupType.value === 'customize') {
          if (vm.$store.getters.getPackage === 'premium') {
            vm.estimateReach(vm.groupType.value)
          } else {
            vm.estimateReach('')
          }
        } else {
          vm.estimateReach(vm.groupType.value)
        }
      }
    })
    if (this.value && this.value.m_condition) {
      let a = this.value.m_condition.split('&')
      let b = {}
      a.forEach((v) => {
        let x = v.split('=')
        b[x[0]] = x[1]
      })
      let c = {
        uu_areaname: b.uu_areaname,
        uu_dma: b.uu_dma,
        uu_name: b.uu_name,
        uu_register_status: b.uu_register_status,
      }
      Object.assign(this.filter, c)
    }
  },
  computed: {
    view() {
      var defaultview = 'detail'
      if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
        defaultview = 'couponreport'
      }
      this.viewPage = this.$route.query.view ? this.$route.query.view : defaultview
      return this.$route.query.view ? this.$route.query.view : defaultview
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
    }),
    menuItem() {
      if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
        return this.menuData.filter((el) => {
          return ['couponreport', 'techproviderandproductreport'].includes(el.view)
        })
      } else {
        return this.menuData
      }
    },
    messageAvailableCount: function () {
      return false
    },
    filterIntent: function () {
      var vm = this
      if (vm.intents && vm.intents.length > 0) {
        vm.intents.sort(function (a, b) {
          var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
          var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
          if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
            return 1
          }
          if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
            return -1
          }
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
      }
      var intents = []
      if (vm.intents) {
        vm.intents.map(function (intent, index) {
          intents.push(intent.intentname)
        })
      }
      return intents
    },
    choices: {
      get() {
        let vm = this
        if (vm.quick_reply && vm.quick_reply !== '') {
          var quickReplies = []
          quickReplies = vm.quick_reply.split(',')
          var result = []
          if (quickReplies) {
            quickReplies.map(function (val, index) {
              result.push({ text: val })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (val, index) {
            result.push(val.text)
          })
        }
        vm.quick_reply = result.join(',')
      },
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      },
    },
    test_update_tags: {
      get() {
        let vm = this
        if (vm.tag_reply && vm.tag_reply !== '') {
          var tagReplies = []
          tagReplies = vm.tag_reply.split(',')
          var result = []
          if (tagReplies) {
            tagReplies.map(function (val, index) {
              result.push({ text: val })
            })
          }
          return result
        } else {
          return []
        }
      },

      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.tag_reply = result.join(',')
      },
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function (s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      },
    },
    areaName: function () {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },
  },
  methods: {
    open() {
      this.$refs.multiselect.activate()
    },
    close() {
      this.$refs.multiselect.deactivate()
    },
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    },
    showEditTimeScheduleFunc() {
      this.showEditTimeSchedule = true
      this.reset()
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.update_tags.push(tag)
    },
    allowedStep: (m) => m % 10 === 0,
    onChangeStatus() {
      if (this.groupType === 'customize') {
        if (this.$store.getters.getPackage === 'premium') {
          this.estimateReach(this.groupType)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(this.groupType)
      }
    },
    onBroadcastSchedule() {
      // this.broadcast.isschedule = !this.broadcast.isschedule
      this.$set(this.broadcast, 'isschedule', !this.broadcast.isschedule)
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 99999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 50) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    addChoices: function (newTags) {
      let vm = this
      this.choices = newTags
      vm.$store.dispatch('loading')
      this.onSave()
    },
    addTestUpdate: function (newTags) {
      this.update_tag = newTags
    },

    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 100) {
        this.errorTag.push('overmaxlength')
        obj.error()
        // } else if (this.choices.length >= 10) {
        //   this.errorTag.push('overtagmax')
        //   obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    },
    getIntent: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
      }
      api.getIntent(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          response.data.map(function (val, index) {
            var intent = val
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    onActiveStartDate: function (value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    onOptionChange: function (option) {
      this.type = option
      // this.saveWelcomeMessage()
    },
    onDeleteGeneric: function (index) {
      if (this.generics.length > 1) {
        this.generics.splice(index, 1)
      } else {
        alert('Generic Message cannot be less than 1')
      }
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    addGeneric: function () {
      if (this.generics.length < 10) {
        this.generics.push({
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        })
      }
    },
    onBack: function () {
      var vm = this
      let current = this.$router.history.current.path
      this.$router.push(current)
      vm.$emit('onClose')
    },

    onSubmitModal: function () {
      var vm = this
      vm.$store.dispatch('loading')
      vm.test_update_tags = vm.update_tag
      vm.onSave()
    },
    onSave: function () {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          console.log('ERROR')

          return false
        }
        vm.updateBroadcast(false, function (status) {
          if (status) {
            vm.$swal.fire({
              title: vm.$t('Success! Broadcast {name} save', {
                name: vm.name.replace(/\<|\>/g, ''),
              }),
              type: 'success',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true,
            })
          } else {
            vm.$swal.fire({
              title: vm.$t('Oop! Broadcast {name} save draft fail', {
                name: vm.name.replace(/\<|\>/g, ''),
              }),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true,
            })
          }

          $('html, body').animate({ scrollTop: 0 })
          vm.showEditNameModal = false
          vm.showEditTarget = false
          vm.showEditTags = false
          vm.showEditTimeSchedule = false
          // vm.$store.dispatch('loading')
        })
      })
    },
    onSend: function () {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.groupType.value === 'customize' && vm.$store.getters.getPackage !== 'premium') {
          vm.showUpgrade = true
          return false
        }
        vm.$swal
          .fire({
            title: vm.$t('Do you want to broadcast {name}?', {
              name: vm.name.replace(/\<|\>/g, ''),
            }),

            type: 'question',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true,
          })
          .then((result) => {
            if (result.value) {
              vm.$store.dispatch('loading')
              vm.updateBroadcast(true, function (status) {
                if (status) {
                  vm.$swal
                    .fire({
                      title: vm.$t('Broadcast {sent_name} sent', {
                        sent_name: vm.name.replace(/\<|\>/g, ''),
                      }),
                      type: 'success',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true,
                    })
                    .then(function () {
                      vm.$emit('onClose', vm.name)
                    })
                  vm.$store.dispatch('loading')
                } else {
                  vm.$store.dispatch('loading')
                  vm.$swal.fire({
                    title: vm.$t('Oop! Broadcast {name} save draft fail', {
                      name: vm.name.replace(/\<|\>/g, ''),
                    }),
                    type: 'error',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true,
                  })
                  vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
              })
            }
          })
      })
    },
    updateBroadcast: function (isSend, callback) {
      var vm = this
      var vm = this
      if (vm.scheduleDate !== null && vm.scheduleTime !== null) {
        var scheduletime =
          moment(vm.scheduleDate).format('YYYY-MM-DD') +
          ' ' +
          moment(vm.scheduleTime).format('HH:mm')
        var scheduletimeUTC = moment(scheduletime)
      } else {
        var scheduletimeUTC = undefined
      }

      var data = {
        pageid: vm.selectedBot.pageid,
        name: vm.name,
        m_val: vm.message,
        m_type: 'json',
        m_quick_reply: vm.quick_reply,
        m_condition: '',
        sendflag: isSend,
        page_access_token: vm.selectedBot.page_access_token,
        pushtype: vm.pushtype,
        sendtype: vm.sendtype,
        update_status: vm.update_status,
        update_tags: vm.tag_reply ? vm.tag_reply.split(',') : [],
      }

      if (scheduletimeUTC !== undefined) {
        data.isschedule = true
        data.scheduletime = scheduletimeUTC.format('YYYY-MM-DDTHH:mm:ss.sssZ')
      } else {
        data.isschedule = false
        data.scheduletime = null
      }

      if (vm.groupType.value === 'facebook') {
        data.m_condition = 'app=facebook'
      } else if (vm.groupType.value === 'line') {
        data.m_condition = 'app=line'
      } else if (vm.groupType.value === 'customize') {
        data.filter = vm.filter
      }

      if (vm.broadcast && vm.broadcast.id) {
        data.broadcastid = vm.broadcast.id
      }

      var messages = vm.checkEmptyMessage(vm.messages)
      if (isSend == true && (messages.length == 0 || messages[0].length == 0)) {
        callback(false)
        return false
      }
      data.m_val = JSON.stringify(messages)
      vm.$emit('onSave', {
        data: data,
        onSave: function (status, broadcastid) {
          if (status) {
            if (broadcastid) {
              data.id = broadcastid
            }
            vm.broadcast = data
            vm.cached_broadcast = Object.assign({}, vm.broadcast)
          }
          callback(status)
        },
      })
    },
    estimateReach: function (type) {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
      }
      if (type === 'customize') {
        data.filter = vm.filter
        if (data.filter.uu_areaname == 'ทุกพื้นที่') {
          data.filter.uu_areaname = ''
        }
      } else {
        if (type === 'facebook') {
          Object.assign(data, { app: 'facebook' })
        } else if (type === 'line') {
          Object.assign(data, { app: 'line' })
        }
      }
      vm.loadingEstimate = true
      api.estimateReach(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingEstimate = false
          return
        }
        if (response.data) {
          vm.estimate_user = response.data.count
          vm.total_user = response.data.total
        } else {
          vm.estimate_user = 0
        }
        vm.$nextTick(function () {
          vm.loadingEstimate = false
        })
      })
    },
    onSelectGroupType: function (type) {
      if (type.value === 'customize') {
        if (this.$store.getters.getPackage === 'premium') {
          this.estimateReach(type.value)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(type.value)
      }
    },
    reset: function () {
      var vm = this
      // vm.getIntent(function() {})
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)

        this.update_status = vm.broadcast.update_user_status
        this.update_tags = vm.broadcast.update_tags
        this.tag_reply = vm.broadcast.update_tags.toString()

        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter((el) => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters.map(function (filter, index) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              switch (value[0]) {
                case 'fullname':
                case 'gender':
                case 'app':
                case 'email':
                case 'context':
                case 'membername':
                case 'membertype':
                case 'memberstatus':
                case 'dpType':
                case 'projectname':
                case 'projecttype':
                case 'status':
                case 'tags':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  return { id: value[0], value: value[1] }
                  break
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: messagesent[0] + '__',
                  }
                  return {
                    id: value[0],
                    value: {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__',
                    },
                  }
                  break
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  vm.filter.locale = vm.localeOptions
                    .map((configLocal, clindex) => {
                      if (locales.includes(configLocal.value)) {
                        return configLocal
                      } else {
                        return null
                      }
                    })
                    .filter((el) => {
                      return el != null
                    })
                  return { id: 'locale', value: vm.filter.locale }
                  break
                case 'intent':
                  vm.filter.intent = value[1].split(',')
                  return { id: 'intent', value: value[1].split(',') }
                  break
                case 'timestamp_from':
                  vm.filter.activeDate.start = moment(value[1]).toDate()
                  return { id: 'activeDate_start', value: moment(value[1]).toDate() }
                  break
                case 'timestamp_to':
                  vm.filter.activeDate.end = moment(value[1]).toDate()
                  return { id: 'activeDate_end', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = moment(value[1]).toDate()
                  return { id: 'registerDate_start', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = moment(value[1]).toDate()
                  return { id: 'registerDate_end', value: moment(value[1]).toDate() }
                  break
              }
            }
          })
          if (f.length == 1 && (vm.filter['app'] == 'facebook' || vm.filter['app'] == 'line')) {
            vm.groupType =
              vm.filter['app'] == 'facebook' ? vm.groupTypeOptions[1] : vm.groupTypeOptions[2]
          } else {
            vm.groupType = vm.groupTypeOptions[1]
          }
        } else {
          vm.groupType = vm.groupTypeOptions[0]
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype ? vm.broadcast.sendtype : 'promotion'
        vm.pushtype = vm.broadcast.pushtype ? vm.broadcast.pushtype : 'SILENT_PUSH'

        if (vm.broadcast.scheduletime) {
          var scheduleDate = moment.utc(vm.broadcast.scheduletime).toDate()
          vm.scheduleDate = scheduleDate
          vm.scheduleTime = scheduleDate
        } else {
          vm.scheduleDate = null
          vm.scheduleTime = null
        }

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square',
              },
            ],
          ]
        } else if (vm.broadcast.m_type == 'json') {
          try {
            vm.messages = JSON.parse(vm.broadcast.m_val)
          } catch (error) {}
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function (index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function (index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message,
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button',
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message,
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message,
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = {
          m_condition: null,
          name: null,
          m_type: 'json',
          m_quick_reply: null,
          m_val: null,
        }
        vm.isSave = false
        vm.isFail = false
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.test_update_tag = ''
        vm.messages = [[]]
        vm.choice = ''
        vm.errorTag = []
        vm.estimate_user = 0
      }
      vm.$nextTick(function () {
        if (vm.groupType.value == 'customize') {
          if (vm.$store.getters.getPackage == 'premium') {
            vm.estimateReach(vm.groupType.value)
          } else {
            vm.estimateReach('')
          }
        } else {
          vm.estimateReach(vm.groupType.value)
        }
      })

      // if (vm.name == '') {
      //   vm.name = 'Broadcast_' + moment().format('YYYY_MM_DD_HH_mm')
      // }
    },
  },
  watch: {
    value: function (newVal, oldVal) {
      var vm = this
      vm.reset()
    },
    filter: {
      handler: function (newValue) {
        if (this.groupType && this.groupType.value == 'customize') {
          this.estimateReach(this.groupType.value)
        }
      },
      deep: true,
    },
    groupType: function () {},
    showSponser: function (newVal, oldVal) {
      if (newVal == false && oldVal == true) {
        this.sendtype = 'promotion'
      }
    },
    sendtype: function (newVal) {
      if (newVal == 'sponsered') {
        this.showSponser = true
      }
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastManage.vue